import React from 'react';
import { Typography, Box, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

/**
 * Compact CTA bar for mobile devices only.
 * Desktop users see the CTA in the HeroSection instead.
 */
const HomePageSearch: React.FC = () => {
    const navigate = useNavigate();

    const handleFindBoat = () => {
        navigate('/quoter');
    };

    return (
        <Paper
            elevation={0}
            sx={{
                display: { xs: 'flex', md: 'none' }, // Mobile only
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
                p: 2,
                backgroundColor: 'background.paper',
                borderRadius: 2,
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                border: '1px solid',
                borderColor: 'divider',
            }}
        >
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="subtitle1"
                    sx={{
                        fontWeight: 600,
                        fontSize: '1rem',
                        color: 'primary.main',
                        lineHeight: 1.3,
                    }}
                >
                    Instant Sail Pricing
                </Typography>
            </Box>
            <Button
                variant="contained"
                onClick={handleFindBoat}
                sx={{
                    backgroundColor: 'orange.main',
                    color: 'white',
                    fontSize: '0.938rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    px: 2.5,
                    py: 1,
                    minWidth: '120px',
                    borderRadius: '8px',
                    flexShrink: 0,
                    '&:hover': {
                        backgroundColor: 'orange.dark',
                    },
                }}
            >
                Find Boat →
            </Button>
        </Paper>
    );
};

export default HomePageSearch;
